import { render, staticRenderFns } from "./CreateAgentPage.vue?vue&type=template&id=56efeed6&scoped=true"
import script from "./CreateAgentPage.vue?vue&type=script&lang=js"
export * from "./CreateAgentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efeed6",
  null
  
)

export default component.exports